import React from 'react';
import { createRoot } from 'react-dom/client';
import { Editor } from '@remotion-fast/ui';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<Editor />);
}
